import gql from 'graphql-tag';

/** Είδη εισφορών μαζί με ομάδα, υποομάδα και ιστορικό τιμών */
export const gqlGetCntItems = gql`
  query getCntItems($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntItems(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        code
        fullName
        units1
        units2
        units3
        priceCalculationMethod
        hasDetails
        useInEmpa
        useInNonEdoe
        useInEdoe
        useInEdoeUsed
        empaCategory
        erpItemCode
        enName
        enFootnote
        enEmpaCategory
        erpItemName
        isActive
        group {
          id
          name
        }
        subgroup {
          id
          name
        }
        itemPrices {
          id
          fromDate
          price
          priceCalculationMethod
          isActive
        }
      }
      recordCount
    }
  }
`;

/** Ένα είδος εισφοράς με ομάδα, υποομάδα και ιστορικό τιμών για τη φόρμα επεξεργασίας */
export const gqlGetCntItemById = gql`
  query getCntItemById($id: Int) {
    getCntItemById(id: $id) {
      id
      name
      code
      fullName
      footnote
      groupId
      subgroupId
      units1
      units2
      units3
      priceCalculationMethod
      hasDetails
      useInEmpa
      useInNonEdoe
      useInEdoe
      useInEdoeUsed
      empaCategory
      erpItemCode
      enName
      enFootnote
      enEmpaCategory
      erpItemName
      enErpItemName
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      group {
        id
        name
      }
      subgroup {
        id
        name
      }
      itemPrices {
        id
        fromDate
        price
        priceCalculationMethod
        isActive
      }
    }
  }
`;

export const gqlUpdateCntItem = gql`
  mutation updateCntItem($data: CntItemInput) {
    updateCntItem(data: $data) {
      id
    }
  }
`;

export const gqlDeleteCntItem = gql`
  mutation deleteCntItem($id: Int) {
    deleteCntItem(id: $id)
  }
`;

/** Πεδία που γράφονται στο cnt_items. Τα audit πεδία τα συμπληρώνει ο server. */
export class FormInput {
  id: number;
  name: string;
  code: string;
  fullName: string;
  footnote: string;
  groupId: number;
  subgroupId: number;
  units1: string;
  units2: string;
  units3: string;
  priceCalculationMethod: number;
  hasDetails: boolean;
  useInEmpa: boolean;
  useInNonEdoe: boolean;
  useInEdoe: boolean;
  useInEdoeUsed: boolean;
  empaCategory: string;
  erpItemCode: string;
  enName: string;
  enFootnote: string;
  enEmpaCategory: string;
  erpItemName: string;
  enErpItemName: string;
  isActive: boolean;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.code = undefined;
    this.fullName = undefined;
    this.footnote = undefined;
    this.groupId = undefined;
    this.subgroupId = undefined;
    this.units1 = undefined;
    this.units2 = undefined;
    this.units3 = undefined;
    this.priceCalculationMethod = undefined;
    this.hasDetails = undefined;
    this.useInEmpa = undefined;
    this.useInNonEdoe = undefined;
    this.useInEdoe = undefined;
    this.useInEdoeUsed = undefined;
    this.empaCategory = undefined;
    this.erpItemCode = undefined;
    this.enName = undefined;
    this.enFootnote = undefined;
    this.enEmpaCategory = undefined;
    this.erpItemName = undefined;
    this.enErpItemName = undefined;
    this.isActive = undefined;
  }
}
